require('./admin/bootstrap')
require('./admin/main-admin')

import { createApp } from 'vue'
import {
    Button,
    HasError,
    AlertError,
    AlertErrors,
    AlertSuccess
} from 'vform/src/components/bootstrap5'
import TableCustomFields from './admin/components/ui/table-custom-fields.vue'
import Categories from './admin/components/products/Categories.vue'
import Variants from './admin/components/products/Variants.vue'

createApp({
    data () {
        return {
            tableCheckAllRows: false,
            tableCheckedRows: [],
            tableCheckedRowsUuids: '',
            tableBatchAction: '',
            tableFields: []
        }
    },
    created () {
        this.tableFields = window.tableCustomFields || [];
    },
    methods: {
        // Selecciona / Deselecciona todos los checkboxes de las filas de la tabla
        tableCheckAllToggle () {
            // verifica si el checkbox no esta seleccionado
            if( ! this.tableCheckAllRows) {
                // Deselecciona todos los checkboxes de la tabla y reinicia la acción del select
                this.tableCheckedRows = [];
                this.tableBatchAction = '';
            } else {

                // Limpia la selección previa de los checkboxes
                this.tableCheckedRows = [];

                // busca con jQuery todos los checkboxes de la tabla
                let $tableCheckboxes = $('[data-table-checkbox]');

                let that = this;

                // Itera sobre los checkboxes para obtener su UUID y agregarlo al arreglo de checkboxes seleccionados
                $tableCheckboxes.each(function(index) {
                    that.tableCheckedRows.push($(this).val());
                });
            }
        },
    },
    watch: {
        tableCheckedRows (rows) {
            this.tableCheckedRowsUuids = JSON.stringify(rows);
        }
    }
})
.component(Button.name, Button)
.component(HasError.name, HasError)
.component(AlertError.name, AlertError)
.component(AlertErrors.name, AlertErrors)
.component(AlertSuccess.name, AlertSuccess)
.component('TableCustomFields', TableCustomFields)
.component('Categories', Categories)
.component('Variants', Variants)
.mount('#app')
